import { profileConstants } from '../constants';

export function profileReducers(state = {}, action) {
    switch (action.type) {
            
        // Get User Profile
        
        case profileConstants.getUserProfile_request:
            return {
                ...state,
                getUserProfile_requesting: true, getUserProfile_status: false,
            }
        case profileConstants.getUserProfile_success:
            return {
                ...state,
                getUserProfile_requesting: false, getUserProfile_status: true,
				userProfile: action.details, 
            }
        case profileConstants.getUserProfile_failure:
            return {
                ...state,
                getUserProfile_requesting: false, getUserProfile_status: false, 
            }

        default:
            return state;
    }
}